<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <appProductPartsNamesContainer></appProductPartsNamesContainer>
    <div>
      <component :is="getBundleProductPartType"></component>
      <appUploadContainer></appUploadContainer>
    </div>
    <div class="matrix_summaryInformation">
      <appSummaryTable></appSummaryTable>
      <appInformationTable></appInformationTable>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { useBundleStore } from "@/stores/modules/bundle";
export default {
  computed: {
    ...mapState(useBundleStore, ["getBundleProductPartType"])
  }
};
</script>
